export const VOLUME_STORAGE_KEY = 'VOLUME_STORAGE_KEY';
export const CURRENCY_STORAGE_KEY = 'RECOMMENDED_CURRENCY';
export const LYRICS_PANEL_VISITED_STORAGE_KEY = 'LYRICS_PANEL_VISITED';
export const DEFAULT_VOLUME = 0.2;
export const LAST_BACKGROUND_UPLOAD_STUMP_KEY = 'LAST_BACKGROUND_UPLOAD_STUMP';
export const LAST_LOGO_UPLOAD_STUMP_KEY = 'LAST_LOGO_UPLOAD_STUMP';
export const EXPIRATION_ONBOARDING_INFO_CLOSED_KEY = 'EXPIRATION_ONBOARDING_INFO_CLOSED';
export const FREEZE_VIDEO_BACKGROUND_KEY = 'FREEZE_VIDEO_BACKGROUND';
export const PREVIEW_AUDIO_ANALYSIS_DISABLED_KEY = 'PREVIEW_AUDIO_ANALYSIS_DISABLED';
export const OPTIMIZATION_MODE_KEY = 'OPTIMIZATION_MODE';
export const EDIT_HISTORY_ENABLED_KEY = 'EDIT_HISTORY_ENABLED';
export const ASSET_UPLOADING_MODE_KEY = 'ASSET_UPLOADING_MODE';
export const PRE_OPTIMIZATION_SETTINGS_KEY = 'PRE_OPTIMIZATION_SETTINGS';
export const VIDEO_SETTINGS_FAILURE_TRIGGER_KEY = 'VIDEO_SETTINGS_FAILURE_TRIGGER';

export function getStorageItem(key) {
    return localStorage.getItem(key);
}

export function saveStorageItem(key, data) {
    localStorage.setItem(key, data);
}

export function getAudioVolume() {
    return localStorage.getItem(VOLUME_STORAGE_KEY) ? parseFloat(localStorage.getItem(VOLUME_STORAGE_KEY)) : DEFAULT_VOLUME;
}

export function saveAudioVolume(volume) {
    localStorage.setItem(VOLUME_STORAGE_KEY, volume);
}

export function saveStorageTimestamp(key) {
    localStorage.setItem(key, new Date());
}

export function getStorageTimestamp(key) {
    const timestamp = Date.parse(localStorage.getItem(key));
    return isNaN(timestamp) ? null : timestamp;
}

export function getCurrencyFromStorage() {
    let currency = localStorage.getItem(CURRENCY_STORAGE_KEY);
    return currency ? parseInt(currency) : undefined;
}

export function saveCurrencyToStorage(currency) {
    localStorage.setItem(CURRENCY_STORAGE_KEY, currency);
}

export function saveLyricsPanelVisited(visited) {
    localStorage.setItem(LYRICS_PANEL_VISITED_STORAGE_KEY, visited);
}

export function getLyricsPanelVisited() {
    return Boolean(localStorage.getItem(LYRICS_PANEL_VISITED_STORAGE_KEY));
}

export function getLastBackgroundUpdateStamp() {
    return localStorage.getItem(LAST_BACKGROUND_UPLOAD_STUMP_KEY);
}

export function saveLastBackgroundUpdateStamp(stamp) {
    localStorage.setItem(LAST_BACKGROUND_UPLOAD_STUMP_KEY, stamp);
}

export function getLastLogoUpdateStamp() {
    return localStorage.getItem(LAST_LOGO_UPLOAD_STUMP_KEY);
}

export function saveLastLogoUpdateStamp(stamp) {
    localStorage.setItem(LAST_LOGO_UPLOAD_STUMP_KEY, stamp);
}

export function getFreezeVideoBackground() {
    const freezeVideoBackground = localStorage.getItem(FREEZE_VIDEO_BACKGROUND_KEY);
    return freezeVideoBackground === 'true';
}

export function saveFreezeVideoBackground(freezeVideoBackground) {
    localStorage.setItem(FREEZE_VIDEO_BACKGROUND_KEY, freezeVideoBackground);
}

export function getPreviewAudioAnalysisDisabled() {
    const previewAudioAnalysisDisabled = localStorage.getItem(PREVIEW_AUDIO_ANALYSIS_DISABLED_KEY);
    return previewAudioAnalysisDisabled === 'true';
}

export function savePreviewAudioAnalysisDisabled(previewAudioAnalysisDisabled) {
    localStorage.setItem(PREVIEW_AUDIO_ANALYSIS_DISABLED_KEY, previewAudioAnalysisDisabled);
}

export function getOptimizationMode() {
    return localStorage.getItem(OPTIMIZATION_MODE_KEY) === 'true';
}

export function saveOptimizationMode(optimizationModeEnabled) {
    localStorage.setItem(OPTIMIZATION_MODE_KEY, optimizationModeEnabled);
}

export function getEditHistoryEnabled() {
    // Enabled unless explicitly turned off.
    return localStorage.getItem(EDIT_HISTORY_ENABLED_KEY) !== 'false';
}

export function saveEditHistoryEnabled(editHistoryEnabled) {
    localStorage.setItem(EDIT_HISTORY_ENABLED_KEY, editHistoryEnabled);
}

export function getAssetUploadingMode() {
    // Lazy unless explicitly switched to direct.
    return localStorage.getItem(ASSET_UPLOADING_MODE_KEY) === 'direct' ? 'direct' : 'lazy';
}

export function saveAssetUploadingMode(assetUploadingMode) {
    localStorage.setItem(ASSET_UPLOADING_MODE_KEY, assetUploadingMode);
}

export function getPreOptimizationSettings() {
    try {
        const settings = JSON.parse(localStorage.getItem(PRE_OPTIMIZATION_SETTINGS_KEY));
        return settings && typeof settings === 'object' ? settings : null;
    } catch {
        return null;
    }
}

export function savePreOptimizationSettings(settings) {
    localStorage.setItem(PRE_OPTIMIZATION_SETTINGS_KEY, JSON.stringify(settings));
}

export function clearPreOptimizationSettings() {
    localStorage.removeItem(PRE_OPTIMIZATION_SETTINGS_KEY);
}

export const FEATURES_PANEL_VISITED_STORAGE_KEY = 'specterr_features_panel_visited';
export const TRIED_FEATURES_STORAGE_KEY = 'specterr_tried_features';

export function saveFeaturesPanelVisited(visited) {
    localStorage.setItem(FEATURES_PANEL_VISITED_STORAGE_KEY, visited);
}

export function getFeaturesPanelVisited() {
    return localStorage.getItem(FEATURES_PANEL_VISITED_STORAGE_KEY) === 'true';
}

export function getTriedFeatureIds() {
    try {
        const storedIds = JSON.parse(localStorage.getItem(TRIED_FEATURES_STORAGE_KEY));
        return Array.isArray(storedIds) ? storedIds : [];
    } catch {
        return [];
    }
}

export function saveTriedFeatureId(featureId) {
    const triedFeatureIds = getTriedFeatureIds();

    if (!triedFeatureIds.includes(featureId)) {
        triedFeatureIds.push(featureId);
        localStorage.setItem(TRIED_FEATURES_STORAGE_KEY, JSON.stringify(triedFeatureIds));
    }

    return triedFeatureIds;
}

export function checkAndTriggerVideoSettingsFailure(resourceName) {
    // Warning: This function is used for QA purposes only.
    // To test the different failures during the video settings saving process.

    const triggerValue = localStorage.getItem(VIDEO_SETTINGS_FAILURE_TRIGGER_KEY);
    if (!triggerValue)
        return;

    if (triggerValue === resourceName) {
        localStorage.removeItem(VIDEO_SETTINGS_FAILURE_TRIGGER_KEY);
        throw new Error(`Video settings saving failed MANUALLY for ${resourceName}`);
    }
}
